<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="2" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t($route.meta.title) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Directive -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("DIRECTIVE") }}</strong>
          </td>
          <td>
            <span class="pre-wrap">{{ formGeneral.leadSentence }}</span>
          </td>
        </tr>
        <!-- Verb -->
        <tr>
          <td class="width-3">
            <strong>動詞</strong>
          </td>
          <td>
            <span class="pre-wrap">{{ formGeneral.verb }}</span>
          </td>
        </tr>
        <!-- Question -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("QUESTION") }}</strong>
          </td>
          <td>
            <v-row class="mx-0 my-7">
              <span class="font-weight-bold">{{ formGeneral.name1 }}</span>
              <span
                v-for="(i, index) in formGeneral.answersConjugation"
                :key="index"
                class="mx-2"
                style="border-bottom: 2px solid #ccc; min-width: 1.5rem"
              ></span>
              <span class="font-weight-bold">{{ formGeneral.name2 }}</span>
            </v-row>
          </td>
        </tr>
        <!-- Answer -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("CORRECT_ANSWER") }}</strong>
          </td>
          <td>
            <v-row class="ma-0">
              <span
                class="answers"
                v-for="(answers, index) in formGeneral.answersConjugation"
                :key="`answers-${index}`"
                >{{ answers.value }}</span
              >
            </v-row>
          </td>
        </tr>
        <tr>
          <td class="width-3" rowspan="2">
            <strong>{{ $t("WRONG_ANSWER") }}</strong>
          </td>
          <td>
            <v-row class="ma-0">
              <span
                class="answers"
                v-for="(answers, index) in formGeneral.wrongAnswersConjugation"
                :key="`wrongAnswers-${index}`"
                >{{ answers.value }}</span
              >
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  store: ["formGeneral"],
  props: ["item"],
  methods: {
    checkAnswerCorrect(value) {
      return Boolean(this.item.answer_correct[0] == value);
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    nameConvert(item) {
      let unline = "";
      item.list_answer.answer[0].forEach(() => {
        unline += " __ ";
      });
      return `${this.replaceText(
        item.list_answer.sentence_answer[0]
      )} ${unline} ${this.replaceText(item.list_answer.sentence_answer[1])}`;
    },
  },
};
</script>
<style  scoped>
tr td {
  border: 1px solid #ccc;
  border-top: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
.answers {
  background-color: #eceff1 !important;
  border-color: #eceff1 !important;
  min-width: 70px;
  min-height: 29px;
  padding: 4px 0px;
  border-radius: 4px;
  text-align: center;
  margin-right: 16px;
}
</style>